// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__jYSpC","header":"ReportDetails_header__1HRZj","title":"ReportDetails_title__2urEb","left":"ReportDetails_left__15b-n"};